import React from 'react';
import api from '../../../helpers/api';

import styles from './ContactDistributor.module.scss';
import MultiSelect from '../../miscellaneous/MultiSelect/MultiSelect';
import Loader from '../../miscellaneous/Loader/Loader';
import moment from 'moment';
import { $getLanguage, $t } from '../../../helpers/translator';
import _ from "lodash";
import {connect} from "react-redux";
import {getCountries} from "../../../store/data-slice";

class ContactDistributor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lang: $getLanguage(),

            successMessage: '',
            errorMessage: '',
            loading: false,

            selectedProduct: null,

            values: {
                submitterName: {
                    value: '',
                    validation: [
                        { maxLength: 255 },
                        { required: $t('validation.general.required') },
                    ],
                    error: ''
                },
                submitterEmail: {
                    value: '',
                    validation: [
                        {
                            regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                            errorText: $t('validation.general.email')
                        },
                        { maxLength: 50 },
                        { required: $t('validation.general.required') },
                    ],
                    error: ''
                },
                submitterPhoneNumber: {
                    value: '',
                    validation: [
                        { maxLength: 20 },
                        { required: $t('validation.general.required') },
                        {
                            regex: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                            errorText: $t('validation.general.phoneNumber')
                        },
                    ],
                    error: ''
                },
                submitterCountry: {
                    value: '',
                    validation: [
                        // { required: $t('validation.general.required') },
                    ],
                    error: ''
                },
                submitterCity: {
                    value: '',
                    validation: [
                        { maxLength: 255 },
                        // { required: $t('validation.general.required') },
                    ],
                    error: ''
                },
                submitterZipcode: {
                    value: '',
                    validation: [
                        { maxLength: 50 },
                        // { required: $t('validation.general.required') },
                    ],
                    error: ''
                },
                submitterAddress: {
                    value: '',
                    validation: [
                        { maxLength: 255 },
                        // { required: $t('validation.general.required') },
                    ],
                    error: ''
                },
                text: {
                    value: '',
                    validation: [
                        { maxLength: 255 },
                        { required: $t('validation.general.required') }
                    ],
                    error: ''
                },
                equipment: {
                    value: '',
                    validation: [
                        { required: $t('validation.general.required') }
                    ],
                },
            },
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.state.data.countries && !_.isEqual(this.props.state.data.countries, this.state.countries)) {
            this.setState({countries: this.props.state.data.countries})
        }
    }

    /**
     * triggers whenever props received are changed
     * will initiate component on first component on screen
     * @param nextProps
     */
    async componentWillReceiveProps(nextProps) {
        if (!nextProps.product) {
            this.setState({
                successMessage: '',
                errorMessage: ''
            });
        }

        await this.init(nextProps.product);
    }

    async init(product) {
        if (!this.props.state.data.countries) {
            this.props.dispatch(getCountries());
        } else {
            this.setState({countries: this.props.state.data.countries})
        }
        // if (!this.state.countries) {
        //     await this.getCountries();
        // }

        if (!this.state.equipment) {
            await this.getEquipment();
        }

        if (!this.state.userData) {
            await this.getUserData();
        }

        this.selectProduct(product);
        await this.prefillForm();
        this.resetForm();
    }

    async getEquipment() {
        try {
            let res = await api.get('/general/equipment');
            if (res && res.data && res.data.data) {
                _.forEach(res.data.data, (v) => {
                    v.label = v.name;
                    v.value = v.name;
                });
                this.setState({ equipment: res.data.data }, () => {
                    // if (this.props.product) {
                    //     this.selectProduct(this.props.product)
                    // }
                });

            }
        } catch (e) {
            console.error('err getting equipment,', e);
        }
    }

    // async getCountries() {
    //     try {
    //         let res = await api.get('/general/countries');
    //         if (res && res.data) {
    //             _.forEach(res.data, (v, k) => {
    //                 v.label = $t('countries.' + v.name);
    //                 v.value = v.id;
    //             });
    //             this.setState({ countries: res.data });
    //         }
    //     } catch (e) {
    //         console.error('err getting countries,', e);
    //     }
    // }

    async getUserData() {
        try {
            let res = await api.get('/account');
            if (res && res.data) {
                this.setState({ userData: res.data }, async () => {
                    await this.prefillForm();
                });
            }
        } catch (e) {
            console.error('err getting user data,', e);
        }
    }

    async prefillForm() {
        let values = { ...this.state.values };
        let userData = { ...this.state.userData };

        values.submitterName.value = userData.userName ? userData.userName : '';
        values.submitterEmail.value = userData.userEmail ? userData.userEmail : '';
        values.submitterPhoneNumber.value = userData.phone ? userData.phone : '';
        values.submitterCity.value = userData.city ? userData.city : '';
        values.submitterAddress.value = userData.address ? userData.address : '';
        values.text.value = $t('global.service.contactDistributor.contentInitialText');

        let index = _.findIndex(this.state.countries, function (o) {
            return o.value === userData.country;
        });
        if (index && index >= 0 && this.state.countries) {
            values.submitterCountry.value = this.state.countries[index];
        }
    }

    selectProduct(product) {
        if (product) {
            product.value = product.name;
            product.label = product.name;
        }

        let values = { ...this.state.values };
        values.equipment.value = product;

        this.setState({
            values: values,
            selectedProduct: product
        });
    }

    async formSentClickHandler() {
        this.setState({
            successMessage: '',
            errorMessage: ''
        });

        let validated = this.validateForm();
        if (validated) {
            let payload = {
                submitterName: this.state.values.submitterName.value,
                submitterPhoneNumber: this.state.values.submitterPhoneNumber.value,
                submitterEmail: this.state.values.submitterEmail.value,
                submitterCountry: this.state.values.submitterCountry.value.label,
                submitterCity: this.state.values.submitterCity.value,
                submitterZipcode: this.state.values.submitterZipcode.value,
                submitterAddress: this.state.values.submitterAddress.value,

                equipment: this.state.values.equipment.value.label,
                text: this.state.values.text.value,
                date: moment().format('YYYY-MM-DD HH:mm:ss'),

                // test_email: 'alon.laniado@almalasers.co.il'
            };

            try {
                this.setState({ loading: true }, async () => {
                    // let res = await api.contactDistributorAboutProduct(payload);
                    let res = await api.post('/general/equipment/request', payload);

                    if (!res || !res.data || !res.data.success) {
                        let error = res.data && res.data.error && res.data.error.errorText ? res.data.error.errorText : 'Error submitting form';
                        this.setState({
                            errorMessage: error,
                            loading: false
                        });
                        return;
                    }
                    this.setState({
                        successMessage: $t('global.service.serviceCall.serviceCallReceived'),
                        loading: false,
                    }, async () => {
                        this.selectProduct(null);
                    });
                });
            } catch (e) {
                console.error('err sending contact us', e);
            } finally {

            }
        }
    }

    validateForm() {
        let validated = true;
        let values = { ...this.state.values };

        _.forEach(values, (v, k) => {
            v.error = '';
            _.forEach(v.validation, (valObj, valKey) => {
                // console.log('>>>', v, valObj)

                if (!v.value) {
                    v.value = ''
                }

                if (valObj.regex) {
                    if (!(valObj.regex).test(v.value)) {
                        v.error = valObj.errorText;
                        validated = false;
                    }
                }
                if (valObj.required && (!v.value.length && !v.value)) {
                    v.error = valObj.required;
                    validated = false;
                }
                if (valObj.maxLength && v.value.length > valObj.maxLength) {
                    v.error = $t('validation.general.general.maxLength').replace('[0]', valObj.maxLength);
                    validated = false;
                }
            });
        });

        let errorMessage = validated ? '' : $t('global.service.serviceCall.someFieldsContainErrors');

        this.setState({
            values: values,
            errorMessage: errorMessage
        });

        return validated;
    }

    valueChangeHandler(e) {
        // console.log('valueChangeHandler-valueChangeHandler', e.target.name, e.target.value);
        let values = { ...this.state.values };
        values[e.target.name].value = e.target.value;
        values[e.target.name].error = '';

        this.setState({ values: values });
    }

    selectChangeHandler(field, data) {
        // console.log(data);
        let values = { ...this.state.values };
        values[field].value = data;
        values[field].error = '';

        this.setState({ values: values }, () => {
            // console.log(this.state);
        });
    }

    resetForm() {
        let state = { ...this.state };

        if (state.successMessage) {
            _.forEach(state.values, (v) => {
                v.value = '';
            });
        }
        _.forEach(state.values, (v) => {
            v.error = '';
        });

        state.successMessage = '';
        state.errorMessage = '';

        this.setState(state);
    }

    getTime() {
        return moment().locale(this.state.lang).format('LLLL');
        // return moment().format('DD-MM-YYYY HH:mm:ss')
    }


    render() {

        return (
            <div className={`${styles['container']}`}>
                {this.state.successMessage ?
                    <div className={`${styles['success']}`}>
                        <div>
                            <div className={`${styles['bold']}`}>{$t('global.service.serviceCall.serviceCallReceived')}</div>
                            <div>{$t('global.service.serviceCall.emailSent')}</div>
                        </div>
                    </div>
                    :
                    null
                }
                {
                    this.state.loading ?
                        <div className={`${styles['overlay']}`}>
                            <Loader/>
                        </div>
                        :
                        null
                }
                {!this.state.successMessage ?
                    <div>
                        <div className={`${styles['row']} ${styles['cu-header']}`}>
                            <div>{$t('global.service.contactDistributor.contactDistributor')}</div>
                        </div>
                        <div  className={`${styles['section']}`}>
                            <div className={`${styles['field']}`}>
                                <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.name')}</div>
                                <input name="submitterName"
                                       className={'alma-input'}
                                       type="text"
                                       value={this.state.values.submitterName.value}
                                       placeholder={$t('global.service.serviceCall.enterYourName')}
                                       onChange={(e) => this.valueChangeHandler(e)}
                                />
                                <div className={`${styles['error-text']}`}>{this.state.values.submitterName.error}</div>
                            </div>
                            <div className={`${styles['row']}`}>
                                <div className={`${styles['field']}`}>
                                    <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.phoneNumber')}</div>
                                    <input name="submitterPhoneNumber"
                                           className={'alma-input'}
                                           type="tel"
                                           value={this.state.values.submitterPhoneNumber.value}
                                           placeholder={$t('global.service.serviceCall.enterPhoneNumber')}
                                           onChange={(e) => this.valueChangeHandler(e)}
                                    />
                                    <div className={`${styles['error-text']}`}>{this.state.values.submitterPhoneNumber.error}</div>
                                </div>
                                <div className={`${styles['field']}`}>
                                    <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.email')}</div>
                                    <input name="submitterEmail"
                                           className={'alma-input'}
                                           type="text"
                                           value={this.state.values.submitterEmail.value}
                                           placeholder={$t('global.service.serviceCall.enterEmail')}
                                           onChange={(e) => this.valueChangeHandler(e)}
                                    />
                                    <div className={`${styles['error-text']}`}>{this.state.values.submitterEmail.error}</div>
                                </div>
                            </div>
                        </div>


                        <div  className={`${styles['section']}`}>
                            <div className={`${styles['row']}`}>
                                <div className={`${styles['field']}`} style={{ minWidth: '200px' }}>
                                    <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.country')}</div>
                                    {this.state.countries ?
                                        <MultiSelect
                                            name="submitterCountry"
                                            placeholder={$t('global.service.serviceCall.selectCountry')}
                                            options={this.state.countries}
                                            selected={this.state.values.submitterCountry.value}
                                            onValueChange={(data) => this.selectChangeHandler('submitterCountry', data)}
                                        />
                                        :
                                        null
                                    }
                                    <div className={`${styles['error-text']}`}>{this.state.values.submitterCountry.error}</div>
                                </div>
                                <div className={`${styles['field']}`} style={{ minWidth: '200px' }}>
                                    <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.city')}</div>
                                    <input name="submitterCity"
                                           className={'alma-input'}
                                           type="text"
                                           value={this.state.values.submitterCity.value}
                                           placeholder={$t('global.service.serviceCall.selectCity')}
                                           onChange={(e) => this.valueChangeHandler(e)}
                                    />
                                    <div className={`${styles['error-text']}`}>{this.state.values.submitterCity.error}</div>
                                </div>
                                <div className={`${styles['field']}`} style={{ minWidth: '200px' }}>
                                    <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.zipCode')}</div>
                                    <input name="submitterZipcode"
                                           className={'alma-input'}
                                           type="tel"
                                           value={this.state.values.submitterZipcode.value}
                                           placeholder={$t('global.service.serviceCall.enterZipCode')}
                                           onChange={(e) => this.valueChangeHandler(e)}
                                    />
                                    <div className={`${styles['error-text']}`}>{this.state.values.submitterZipcode.error}</div>
                                </div>
                            </div>
                            <div className={`${styles['field']}`}>
                                <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.address')}</div>
                                <input name="submitterAddress"
                                       className={'alma-input'}
                                       type="text"
                                       value={this.state.values.submitterAddress.value}
                                       placeholder={$t('global.service.serviceCall.enterAddress')}
                                       onChange={(e) => this.valueChangeHandler(e)}
                                />
                                <div className={`${styles['error-text']}`}>{this.state.values.submitterAddress.error}</div>
                            </div>
                        </div>


                        <div  className={`${styles['section']}`}>
                            <div className={`${styles['field']}`}>
                                <div
                                    className={`${styles['field-header']}`}>{$t('global.service.contactDistributor.productName')}</div>
                                {this.state.equipment ?
                                    <MultiSelect
                                        name="equipment"
                                        placeholder={$t('global.service.contactDistributor.selectProduct')}
                                        options={this.state.equipment}
                                        selected={this.state.values.equipment.value}
                                        onValueChange={(data) => this.selectChangeHandler('equipment', data)}
                                    />
                                    :
                                    null
                                }
                                <div className={`${styles['error-text']}`}>{this.state.values.equipment.error}</div>
                            </div>


                            <div className={`${styles['row']}`}>
                                <div className={`${styles['field']}`}>
                                    <div className={`${styles['field-header']}`}>{$t('global.service.serviceCall.content')}</div>
                                    <textarea name="text"
                                              className={'alma-input alma-input-textarea'}
                                              style={{ height: '150px' }}
                                              rows={5}
                                              value={this.state.values.text.value}
                                              placeholder={$t('global.service.contactDistributor.contentPlaceHolder')}
                                              onChange={(e) => this.valueChangeHandler(e)}
                                    />
                                    <div className={`${styles['error-text']}`}>{this.state.values.text.error}</div>
                                </div>
                            </div>

                        </div>

                        <div className={`${styles['row']} ${styles['bottom-row']}`}>
                            <div className={`${styles['row']} ${styles['bottom-row']} ${styles['error']}`}>
                                <div>{this.state.errorMessage}</div>
                            </div>
                            <div className={'alma-button'}
                                 onClick={() => this.formSentClickHandler()}>{$t('global.service.serviceCall.submit')}</div>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(ContactDistributor);
